import { useState, useEffect, useRef } from "react";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function WelcomeAbout() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const decorativeItems = [];
  const miningImages = [{
    src: "https://theleads.co.za/wp-content/uploads/2026/06/mwr_preview_7cb35756fb-2.jpeg?v=w8mvdnknx4s",
    srcset: "https://theleads.co.za/wp-content/uploads/2026/06/mwr_preview_7cb35756fb-2.jpeg?v=h3twvf2nkvt-wvc-srcset",
    sizes: "https://theleads.co.za/wp-content/uploads/2026/06/mwr_preview_7cb35756fb-2.jpeg?v=m3bo5kkq9b-wvc-sizes",
    alt: "Large yellow mining haul truck operating at an open-pit mine"
  }, {
    src: "https://theleads.co.za/wp-content/uploads/2026/06/mining-background-fhudc9kf01icybea-1-1.jpg?v=dqy9osru5nt",
    srcset: "https://theleads.co.za/wp-content/uploads/2026/06/mining-background-fhudc9kf01icybea-1-1.jpg?v=vm1wgnbh1ej-wvc-srcset",
    sizes: "https://theleads.co.za/wp-content/uploads/2026/06/mining-background-fhudc9kf01icybea-1-1.jpg?v=chxk9eus21f-wvc-sizes",
    alt: "Specialized underground mining equipment in a tunnel"
  }, {
    src: "https://theleads.co.za/wp-content/uploads/2026/06/banner-open-pit-mine-industry-600nw-2586681127.webp?v=c56cddk6bfk",
    srcset: "https://theleads.co.za/wp-content/uploads/2026/06/banner-open-pit-mine-industry-600nw-2586681127.webp?v=0kfg7jnslxr9-wvc-srcset",
    sizes: "https://theleads.co.za/wp-content/uploads/2026/06/banner-open-pit-mine-industry-600nw-2586681127.webp?v=924hduhkxvt-wvc-sizes",
    alt: "High-capacity industrial pumps for mining facility services"
  }];
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "#FFFFFF",
    paddingTop: "50px",
    paddingBottom: "50px",
    fontFamily: "'Open Sans', Arial, sans-serif"
  }} className="![padding:10px_0px_5px_0px] ![margin:5px_0px_0px_0px]">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');`}</style>
      <div className="page-container !m-[10px]">
        <div ref={ref} className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        maxWidth: "860px",
        marginInline: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>
          <div className="flex justify-center mb-[32px] w-full max-w-[400px]">
            <Link to="/" className="![padding:0px_30px_0px_30px]">
              <WvcLogo className="w-full h-auto max-w-[380px] !m-0 ![padding:0px_0px_70px_0px] [&_svg]:w-full [&_svg]:h-auto [&_svg]:max-w-[380px] [&_svg]:!m-0 [&_svg]:![padding:0px_0px_70px_0px]" />
            </Link>
          </div>

          <p style={{
          color: "#757575",
          fontFamily: "'Open Sans', Arial, sans-serif",
          fontSize: "14px",
          fontWeight: 400,
          lineHeight: 1.6,
          textAlign: "center",
          marginBottom: "20px",
          marginTop: 0,
          textTransform: "uppercase"
        }} className="!font-sans !font-normal">
            <b className="!font-sans !text-[rgba(0,70,84,1)] !font-medium !text-sm"><br />The Leads is a trusted supplier of mining equipment and essential facility services in South Africa, dedicated to ensuring the safety and reliability of your operational machinery.<br /><br />We work closely with our clients to deliver tailored solutions that fit the precise needs of their facilities, whether they require welding equipment, high-capacity pumps, underground mining machinery, or specialiSed support.<br /></b>
          </p>

          <div className="flex flex-wrap justify-center gap-4 mt-8 w-full">
            {miningImages.map((image, index) => <div key={index} data-index={index} className="w-full sm:w-[calc(50%-8px)] md:w-[calc(33.33%-11px)]">
                <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="w-full h-48 object-cover rounded-lg shadow-md" />
              </div>)}
          </div>

          <div className="flex justify-center gap-8 mt-8">
            {decorativeItems.map((item, i) => <div key={i} data-index={i} className="flex flex-col items-center gap-2">
                <div className="p-2 bg-gray-50 rounded-lg shadow-sm">
                  
                </div>
                <span className="text-[10px] font-bold uppercase tracking-wider text-gray-500">
                  {item.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}